import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { GET_NODEL } from "types/actions/nodelMaster.action";

  export const getAllNodels = (
  ) => {
    return (dispatch: Dispatch<AppActions>) => {
      dispatch(fetchStart());
      jwtAxios
        .get("nodelMessage", {
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(fetchSuccess());
            dispatch({ type: GET_NODEL, payload: response.data.data });

          } else {
            dispatch(fetchError("Something went wrong, Please try again!"));
          }
        })
        .catch((error) => {
          dispatch(fetchError(error.message));
        });
    };
  };
  
  